import apiClientEffectsMiddleware from 'src/common/middleware/apiClientEffects';
import configureStore from 'src/common/store/configureStore';
import { isDevBuild } from 'src/common/utils/environment';
import dialogMiddleware from '../middleware/dialogMiddleware';
import executeActionNeedingAuth from '../middleware/executeActionNeedingAuth';
import logInfo from '../middleware/logInfo';
import pageTrackingMiddleware from '../middleware/pageTrackingMiddleware';
import unauthenticateMiddleware from '../middleware/unauthenticate';
import apiClientEffectsErrorCallback from '../utils/apiClientEffectsErrorCallback';
import captureReduxError from '../utils/captureReduxError';

export default function configureClientStore(initialState, history, tuneInApiClient, apiBeta) {
  const envMiddleware = [
    unauthenticateMiddleware,
    pageTrackingMiddleware,
    executeActionNeedingAuth,
    dialogMiddleware,
    logInfo,
  ];

  if (isDevBuild()) {
    // use require since redux-logger won't be included in production scripts
    // eslint-disable-next-line global-require
    const { createLogger } = require('redux-logger');

    envMiddleware.push(
      createLogger({
        collapsed: true,
        // predicate determines whether to log actions to the console
        // see window.tiDebug (defined in client/index.js)
        predicate: (getState) => getState()?.app?.debug?.showActionLogs ?? false,
      }),
    );
  }

  const thunkExtraArgument = {
    api: tuneInApiClient,
    apiBeta,
  };

  return configureStore(
    initialState,
    envMiddleware,
    apiClientEffectsMiddleware(tuneInApiClient, apiClientEffectsErrorCallback(tuneInApiClient)),
    captureReduxError,
    thunkExtraArgument,
  );
}
